import { DIALOG_PRIORITIES } from '../../utils/dialogPriorities'

const DIALOG_ID = 'confirm'

const emptyConfirm = () => ({
  show: false,
  title: null,
  icon: null,
  img: null,
  text: null,
  resolveText: null,
  rejectText: null,
  persistent: false,
  promise: null,
  deferred: null,
  resolveButtonColor: null,
  rejectButtonColor: null,
  resolveCallback: null,
  rejectCallback: null,
  resolveLoading: false,
  rejectLoading: false,
  neutralText: null,
  neutralCallback: null,
})

const confirm = {
  namespaced: true,

  state: {
    confirm: emptyConfirm(),
    confirmQueue: [],
  },

  mutations: {
    set(state, { type, value }) {
      state[type] = value
    },
  },

  actions: {
    showConfirm({ commit, state, dispatch }, payload) {
      let deferred = null
      const promise = new Promise(((resolve, reject) => {
        deferred = { resolve, reject }
      }))

      const priority = payload.priority != null ? payload.priority : DIALOG_PRIORITIES.CONFIRM

      const confirmData = {
        show: true,
        title: payload.title,
        icon: payload.icon,
        img: payload.img,
        text: payload.text,
        resolveText: payload.resolveText,
        rejectText: payload.rejectText,
        persistent: payload.persistent,
        promise,
        deferred,
        resolveButtonColor: payload.resolveButtonColor ? payload.resolveButtonColor : 'primary',
        rejectButtonColor: payload.rejectButtonColor ? payload.rejectButtonColor : '',
        resolveCallback: payload.resolveCallback,
        rejectCallback: payload.rejectCallback,
        resolveLoading: false,
        rejectLoading: false,
        neutralText: payload.neutralText,
        neutralCallback: payload.neutralCallback,
        priority,
      }

      if (state.confirm.show) {
        // Если диалог уже открыт, добавляем в очередь
        commit('set', {
          type: 'confirmQueue',
          value: [...state.confirmQueue, confirmData],
        })
      } else {
        // Если диалог закрыт, показываем сразу
        commit('set', {
          type: 'confirm',
          value: confirmData,
        })
      }

      dispatch('dialogQueue/request', { id: DIALOG_ID, priority }, { root: true })

      return promise
    },

    setConfirmLoading({ commit, state }, payload) {
      commit('set', {
        type: 'confirm',
        value: {
          ...state.confirm,
          [payload.type]: payload.value,
        },
      })
    },

    hideConfirm({ state, commit }) {
      commit('set', {
        type: 'confirm',
        value: {
          ...state.confirm,
          show: false,
        },
      })
    },

    clearConfirm({ commit, state, dispatch }) {
      // Проверяем, есть ли что-то в очереди
      if (state.confirmQueue.length > 0) {
        // Берем первый элемент из очереди
        const nextConfirm = state.confirmQueue[0]

        // Удаляем его из очереди
        commit('set', {
          type: 'confirmQueue',
          value: state.confirmQueue.slice(1),
        })

        // Очищаем текущий confirm
        commit('set', {
          type: 'confirm',
          value: emptyConfirm(),
        })

        // Обновляем приоритет слота в dialogQueue под следующий confirm
        dispatch('dialogQueue/release', DIALOG_ID, { root: true })
        dispatch('dialogQueue/request', { id: DIALOG_ID, priority: nextConfirm.priority != null ? nextConfirm.priority : DIALOG_PRIORITIES.CONFIRM }, { root: true })

        setTimeout(() => {
          // Устанавливаем следующий confirm
          commit('set', {
            type: 'confirm',
            value: nextConfirm,
          })
        }, 100)
      } else {
        // Если очередь пуста, очищаем текущий confirm
        commit('set', {
          type: 'confirm',
          value: emptyConfirm(),
        })
        dispatch('dialogQueue/release', DIALOG_ID, { root: true })
      }
    },
  },
}

export default confirm
